export { ConfigManagerService } from './service-setup/ConfigManagerService';

import { diContainer, serviceNames } from './service-setup/diContainer';

diContainer.get(serviceNames.configManagerService).register();
